export default function (value, decimalPlace = 3) {
  if (!value) {
    value = 0
  }
  const parts = parseFloat(value).toFixed(decimalPlace).toString().split('.')
  const num = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
  return num
}



//////////////////
// WEBPACK FOOTER
// ./helper/money.js
// module id = 164
// module chunks = 1